import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  private dialogVisibility = new BehaviorSubject<boolean>(false);

  dialogVisibility$ = this.dialogVisibility.asObservable();

  showDialog() {
    this.dialogVisibility.next(true);
  }

  hideDialog() {
    this.dialogVisibility.next(false);
  }

  toggleDialog() {
    this.dialogVisibility.next(!this.dialogVisibility.value);
  }
}
